<template>
  <div class="w-100">
    <div class="form-input" :class="[ size, { disabled: disabled, focused: focused, filled: value && String(value).length > 0, 'border-danger': errors && errors.length > 0 } ]" @click="$refs.input?.focus()">
      <label v-if="title && title.length || $slots.title" :for="randomId" class="form-input-label d-flex align-items-center justify-content-between">
        <span class="d-flex align-items-center g-2">
          <slot name="title"><span>{{ title }}</span></slot>
          <i v-if="required" class="fas fa-asterisk text-danger" style="font-size: 0.7em"></i>
        </span>
        <span class="d-flex align-items-center g-2">
          <span v-if="(type === 'text' || type === 'textarea') && max && value && value.length > 0">{{ value.length }}/{{ max }}</span>
          <slot name="extra"></slot>
        </span>
      </label>
      <textarea v-if="type === 'textarea'" class="form-input-body m-0 p-0" :id="randomId" ref="input" :maxlength="max" rows="1" :placeholder="placeholder" :value="value" @input="$emit('update:value', $event.target.value); resizeTextarea()" :disabled="disabled" @focus="focused = true; resizeTextarea(); $emit('focus')" @blur="focused = false; $emit('blur')"/>
      <input v-else class="form-input-body" :id="randomId" ref="input" :type="type" :max="max" :maxlength="max" :placeholder="placeholder" :value="value" @input="$emit('update:value', $event.target.value)" :disabled="disabled" @focus="focused = true; $emit('focus')" @blur="focused = false; $emit('blur')"/>
    </div>
    <div v-if="errors && errors.length > 0" class="form-input-errors">
      <div v-for="(error, index) in errors" :key="index" class="text-danger">{{ error }}</div>
    </div>
  </div>
</template>

<script>

export default {
  name: "InputView",
  emits: ["update:value", "focus", "blur"],
  props: {
    type: {
      type: String,
      default: "text",
      validator(value) {
        return ["text", "textarea", "password", "email", "color", "tel"].includes(value);
      }
    },
    title: String,
    max: Number,
    placeholder: String,
    value: [String, Number, Array, Object, Boolean],
    disabled: Boolean,
    size: {
      type: String,
      default: "medium",
      validator(value) {
        return ["small", "medium", "large"].includes(value);
      }
    },
    errors: Array,
    focus: Boolean,
    required: Boolean
  },
  data() {
    return {
      randomId: "input-" + Math.random().toString(),
      focused: false
    }
  },
  mounted() {
    if (this.type === "textarea" && this.value && this.value.length > 0) {
      this.resizeTextarea();
    }
  },
  watch: {
    focus: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          if (this.focus) {
            this.$refs.input?.focus();
          } else {
            this.$refs.input?.blur();
          }
        });
      }
    }
  },
  methods: {
    resizeTextarea() {
      if (this.type === "textarea") {
        this.$refs.input.style.height = "auto";
        this.$refs.input.style.height = (this.$refs.input.scrollHeight) + "px";
      }
    }
  }
}
</script>